var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.751,
    height: 26.751,
    viewBox: "0 0 26.751 26.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-calendar",
    transform: "translate(-23.23 -23.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M49.481,23.23H23.73a.5.5,0,0,0-.5.5V49.481a.5.5,0,0,0,.5.5H49.481a.5.5,0,0,0,.5-.5V23.73A.5.5,0,0,0,49.481,23.23Zm-.5,25.751H24.229V30.005H48.981V48.981Zm0-19.976H24.229V24.229H48.981v4.777Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(26.877 33.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M34.6,48.577H31.03a.5.5,0,0,1-.5-.5V44.56a.5.5,0,0,1,.5-.5H34.6a.5.5,0,0,1,.5.5v3.517A.5.5,0,0,1,34.6,48.577Zm-3.073-1H34.1V45.059H31.529Z",
    transform: "translate(-30.53 -44.06)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M49.492,48.577H45.92a.5.5,0,0,1-.5-.5V44.56a.5.5,0,0,1,.5-.5h3.572a.5.5,0,0,1,.5.5v3.517A.5.5,0,0,1,49.492,48.577Zm-3.073-1h2.573V45.059H46.419Z",
    transform: "translate(-37.98 -44.06)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M64.392,48.577H60.82a.5.5,0,0,1-.5-.5V44.56a.5.5,0,0,1,.5-.5h3.572a.5.5,0,0,1,.5.5v3.517A.5.5,0,0,1,64.392,48.577Zm-3.073-1h2.573V45.059H61.319Z",
    transform: "translate(-45.436 -44.06)",
    fill: "#818181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(26.877 41.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M34.6,63.557H31.03a.5.5,0,0,1-.5-.5V59.54a.5.5,0,0,1,.5-.5H34.6a.5.5,0,0,1,.5.5v3.517A.5.5,0,0,1,34.6,63.557Zm-3.073-1H34.1V60.039H31.529Z",
    transform: "translate(-30.53 -59.04)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M49.492,63.557H45.92a.5.5,0,0,1-.5-.5V59.54a.5.5,0,0,1,.5-.5h3.572a.5.5,0,0,1,.5.5v3.517A.5.5,0,0,1,49.492,63.557Zm-3.073-1h2.573V60.039H46.419Z",
    transform: "translate(-37.98 -59.04)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M64.392,63.557H60.82a.5.5,0,0,1-.5-.5V59.54a.5.5,0,0,1,.5-.5h3.572a.5.5,0,0,1,.5.5v3.517A.5.5,0,0,1,64.392,63.557Zm-3.073-1h2.573V60.039H61.319Z",
    transform: "translate(-45.436 -59.04)",
    fill: "#818181"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c3352fedc959c55121f707c47b457ae6.svg";
export { ForwardRef as ReactComponent };